import DomainModel from './DomainModel'
import User from './User'

class Instruction extends DomainModel {
  constructor(
    private id: string,
    private instructionType: string,
    private state: string,
    private postedOn: string,
    private instruction: string,
    private by: User,
    private to: User,
    private instructionStatus: string | null,
    private instructionStatusEvidence: string | null
  ) {
    super()
  }

  getId = () => this.id
  getInstruction = () => this.instruction
  getBy = () => this.by
  getTo = () => this.to
  getPostedOn = () => this.postedOn
  getState = () => this.state
  getInstructionType = () => this.instructionType
  getInstructionStatus = () => this.instructionStatus
  getInstructionStatusEvidence = () => this.instructionStatusEvidence
}


export default Instruction
